import {Pipe, PipeTransform} from '@angular/core';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Pipe({  name: 'orderBy' })
export class OrderrByPipe implements PipeTransform {
  cookies: Object;
  transform(records: Array<any>, args?: any): any {
    Cookie.set('filterCookieProp', args.property);
    Cookie.set('filterCookieDir', args.direction);
    if(records == null){
      return null;
    }
    return records.sort(function(a, b){

          if(a[args.property] < b[args.property]){
            return -1 * args.direction;
          }
          else if( a[args.property] > b[args.property]){
            return 1 * args.direction;
          }
          else{
            return 0;
          }
        });
    };
}




// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/-pipe/orderby/orderby.pipe.ts